export default {
  curriculum: {
    id: '',
    degree: null,
    faculty: null,
    department: null,
    code: '',
    nameLocal: '',
    nameEng: '',
    certNameLocal: null,
    certNameEng: null,
    certShortNameLocal: null,
    certShortNameEng: null,
    currId: null,
    isOpen: true,
  },
  curricula: [],
  processing: false,
  error: null,
  success: null,
}



